import React, { Children, isValidElement } from "react";

type BreadcrumbsProps = {
  children: React.ReactNode;
  separator?: string;
};

function Breadcrumbs({ children, separator = "/" }: BreadcrumbsProps) {
  const allItems = Children.toArray(children).filter(isValidElement);

  const itemsWithSeparators = allItems.flatMap((item, index, array) => {
    const isLast = index === array.length - 1;
    return isLast
      ? [
          <li key={`item-${index}`} className="text-charcoalGray">
            {item}
          </li>,
        ]
      : [
          <li key={`item-${index}`} className="text-muted">
            {item}
          </li>,
          <li
            key={`sep-${index}`}
            aria-hidden="true"
            className="mx-2 select-none text-muted"
          >
            {separator}
          </li>,
        ];
  });

  return (
    <nav className="mx-4 md:mx-0 mb-4 overflow-x-auto">
      <ol className="flex whitespace-nowrap items-center list-none p-0 m-0">
        {itemsWithSeparators}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
